import React, { Component } from 'react';
import { WIBThemeProvider } from '@web-ib/components/ui';
import { getEnvFromHostname, getEnvString } from '@web-ib/components/support';
import { Button, Footer, TitleBar } from '@bbnpm/bb-ui-framework';
import styles from './mobile_redirect.module.css';
import { getMobileLink } from '../utils/mobile_utils.js';

const HOST = `${window.location.protocol}//${window.location.host}`;

const login = (): void => {
    window.open(`${HOST}/login`, '_self');
};

const openMobileApp = (): void => {
    const link = getMobileLink();
    if (link) {
        window.location.href = link;
    }
};

const DEFAULT_PAGE_TITLE = 'IB Anywhere';

class MobileRedirect extends Component<{}> {
    componentDidMount(): void {
        const title = document.getElementById('app_title');

        const envString = getEnvString(
            getEnvFromHostname(window.location.hostname),
        );

        if (title) {
            if (envString) {
                title.textContent = `${DEFAULT_PAGE_TITLE} (${envString})`;
            } else {
                title.textContent = DEFAULT_PAGE_TITLE;
            }
        }

        setTimeout(() => {
            openMobileApp();
        }, 2000);
    }

    public render() {
        const envString = getEnvString(
            getEnvFromHostname(window.location.hostname),
        );

        const envIndicator = envString ? (
            <span style={{ color: '#00FFFF' }}>{envString}</span>
        ) : (
            ''
        );

        return (
            <WIBThemeProvider>
                <div className={styles.container}>
                    <div className={styles.titlebar_container}>
                        <TitleBar
                            productName={DEFAULT_PAGE_TITLE}
                            envIndicator={envIndicator}
                            skipToId="main-content"
                        />
                    </div>
                    <div className={styles.body_container} id="main-content">
                        <h1>
                            <span className={styles.orange}>
                                Instant Bloomberg
                            </span>
                        </h1>
                        <p>
                            You are being redirected to the Bloomberg mobile
                            application for the best experience on your device.
                            If the app does not open automatically, please click
                            the button below.
                        </p>
                        <div className={styles.buttonContainer}>
                            <Button
                                kind="primary"
                                className={styles.button}
                                onClick={openMobileApp}
                                tabIndex={0}
                            >
                                Open Bloomberg App
                            </Button>
                            <Button
                                kind="secondary"
                                className={styles.button}
                                onClick={login}
                                tabIndex={0}
                            >
                                Continue on Web
                            </Button>
                        </div>
                    </div>
                    <Footer copyright={new Date().getFullYear()} />
                </div>
            </WIBThemeProvider>
        );
    }
}

export default MobileRedirect;
